exports.COLORS = {
  GREY: "#f0f2f5",
  WHITE: "white"
};
